import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-613dbc92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "collaborative-platform" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "grid-content_title" }, "4PL物流协同平台"),
  /*#__PURE__*/_createElementVNode("p", { class: "grid-content_content" }, " 致力运用 \"数智化\" 方式，构建透明化、数据化、 智能化的物流协同平台，让物流更智能、让连接更高效。 ")
], -1))
const _hoisted_5 = { class: "collaborative" }
const _hoisted_6 = { class: "foot-layout-bigbox" }
const _hoisted_7 = { class: "foot-layout-box" }
const _hoisted_8 = { class: "tab-bigbox" }
const _hoisted_9 = {
  key: 0,
  class: "warehousediagram_box"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div data-v-613dbc92><div class=\"warehouse-net\" data-v-613dbc92><p class=\"warehousediagram_box_title\" data-v-613dbc92>仓网</p><p class=\"warehousediagram_box_content\" data-v-613dbc92> 库存一盘货、统一调度、多级仓网协同联动 </p></div><div class=\"transport-network\" data-v-613dbc92><p class=\"warehousediagram_box_title\" data-v-613dbc92>运网</p><p class=\"warehousediagram_box_content\" data-v-613dbc92> 快递网、快运网、零担网、整车网，多运网融合链接 </p></div></div>", 1)
const _hoisted_11 = { class: "img-flow-chart" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "orderflowchart_box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "orderflowchart_box_title" }, " 一站式全流程作业 提供家居仓、运、配、装、售后一站式服务平台 ", -1))
const _hoisted_15 = { class: "orderflowchart_box_content" }
const _hoisted_16 = { class: "orderflowchart_box_content_btn_container" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-bigbox\" data-v-613dbc92><div class=\"footer-Innerbox\" data-v-613dbc92><div class=\"footer-line\" data-v-613dbc92></div><div class=\"footer-font\" data-v-613dbc92>· 林氏，让生活过得更好 ·</div><div class=\"footer-line\" data-v-613dbc92></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_SystemIntroductBox = _resolveComponent("SystemIntroductBox")!
  const _component_WMSClientDialog = _resolveComponent("WMSClientDialog")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "imgs",
      src: `${_ctx.FILESERVICE}/file/4pl/webclient/img/banner.png`,
      alt: "test.png"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemIntroductBoxData, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                key: item.description,
                span: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SystemIntroductBox, {
                    "item-box-data": item,
                    "current-index": index
                  }, null, 8, ["item-box-data", "current-index"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            style: {"cursor":"pointer"},
            class: _normalizeClass(
              _ctx.isShowFristTabState
                ? 'foot-layout-button__active'
                : 'foot-layout-button'
            ),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeShowFirstTab(true)))
          }, " 仓运网图 ", 2),
          _createElementVNode("button", {
            style: {"cursor":"pointer"},
            class: _normalizeClass(
              !_ctx.isShowFristTabState
                ? 'foot-layout-button__active'
                : 'foot-layout-button'
            ),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeShowFirstTab(false)))
          }, " 订单流转图 ", 2)
        ]),
        (_ctx.isShowFristTabState)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  src: `${_ctx.FILESERVICE}/file/4pl/webclient/img/flow-chart_1.png`,
                  alt: "text/PNG"
                }, null, 8, _hoisted_12)
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: _normalizeClass(
                  _ctx.Showing
                    ? 'flow-chart-minibutton__active'
                    : 'flow-chart-minibutton'
                ),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeShowing(true)))
              }, " 发货链路 ", 2),
              _createElementVNode("button", {
                class: _normalizeClass(
                  !_ctx.Showing
                    ? 'flow-chart-minibutton__active'
                    : 'flow-chart-minibutton'
                ),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeShowing(false)))
              }, " 入库链路 ", 2)
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("img", {
                class: "img-flow-chart",
                src: `${_ctx.FILESERVICE}/file/4pl/webclient/img/flow-chart_2.png`,
                alt: "text/PNG"
              }, null, 8, _hoisted_17)
            ], 512), [
              [_vShow, _ctx.Showing]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("img", {
                class: "img-flow-chart",
                src: `${_ctx.FILESERVICE}/file/4pl/webclient/img/flow-chart_3.png`,
                alt: "text/PNG"
              }, null, 8, _hoisted_18)
            ], 512), [
              [_vShow, !_ctx.Showing]
            ])
          ])
        ], 512), [
          [_vShow, !_ctx.isShowFristTabState]
        ])
      ]),
      _hoisted_19
    ]),
    _createVNode(_component_el_dialog, {
      ref: "dialogForm",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      class: "dialog--wms-client",
      width: "460px",
      top: "150px",
      "append-to-body": "",
      "destroy-on-close": "",
      onClose: _ctx.onDialogClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_WMSClientDialog, {
          username: _ctx.userStore.getUserName,
          onCloseDia: _ctx.onDialogClose
        }, null, 8, ["username", "onCloseDia"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ]))
}